import { AmplienceImage } from 'components/amplience/types';

export const imageAmplienceToUrl = (amplienceImage: AmplienceImage): string => {
  return `https://${amplienceImage?.defaultHost}/i/${amplienceImage?.endpoint}/${amplienceImage?.name}`;
};
